import type { AppIconProps } from "../IconTypes";

export const ChevronRightIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.146 3.646C4.09944 3.69245 4.06249 3.74762 4.03729 3.80837C4.01208 3.86911 3.99911 3.93423 3.99911 4C3.99911 4.06577 4.01208 4.13089 4.03729 4.19163C4.06249 4.25238 4.09944 4.30755 4.146 4.354L7.793 8L4.146 11.646C4.05211 11.7399 3.99937 11.8672 3.99937 12C3.99937 12.1328 4.05211 12.2601 4.146 12.354C4.23989 12.4479 4.36723 12.5006 4.5 12.5006C4.63278 12.5006 4.76011 12.4479 4.854 12.354L8.854 8.354C8.90056 8.30755 8.93751 8.25238 8.96271 8.19163C8.98792 8.13089 9.00089 8.06577 9.00089 8C9.00089 7.93423 8.98792 7.86911 8.96271 7.80837C8.93751 7.74762 8.90056 7.69245 8.854 7.646L4.854 3.646C4.80756 3.59944 4.75238 3.56249 4.69163 3.53729C4.63089 3.51208 4.56577 3.49911 4.5 3.49911C4.43423 3.49911 4.36911 3.51208 4.30837 3.53729C4.24762 3.56249 4.19245 3.59944 4.146 3.646ZM11.5 1C11.6326 1 11.7598 1.05268 11.8536 1.14645C11.9473 1.24021 12 1.36739 12 1.5V14.5C12 14.6326 11.9473 14.7598 11.8536 14.8536C11.7598 14.9473 11.6326 15 11.5 15C11.3674 15 11.2402 14.9473 11.1464 14.8536C11.0527 14.7598 11 14.6326 11 14.5V1.5C11 1.36739 11.0527 1.24021 11.1464 1.14645C11.2402 1.05268 11.3674 1 11.5 1Z"
        fill="#1D9F81"
      />
    </svg>
  );
};
